// AXIOS
import axios from "axios";

// API URL
import { apiToken, apiUrl_forSliders } from "./constants";

// CANCEL TOKEN
const CancelToken = axios.CancelToken;

// GET SLIDERS
export let cancelGetHomeSliderImagesApi;
export async function getHomeSliderImages(token) {
    const data = await axios.get(
        apiUrl_forSliders,
        {
            headers: {
                "Authorization": `Bearer ${token ?? ""}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
        },
        {
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetHomeSliderImagesApi = c;
            }),
        }
    );

    return data;
}
